import apiClient from '@u/apiClient'
import GetNotificationListController from '@/wayfinder/actions/App/Http/Controllers/Notification/GetNotificationListController'
import NotificationMarkAsReadController from '@/wayfinder/actions/App/Http/Controllers/Notification/NotificationMarkAsReadController'
import GetNotificationSubscriptionByDossierIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetNotificationSubscriptionByDossierIdController'
import UpdateNotificationSubscriptionByDossierIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateNotificationSubscriptionByDossierIdController'
import SendNotificationToUsers from '@/wayfinder/actions/App/Http/Controllers/Notification/SendNotificationToUsers'

export default {
  // region fetch
  fetchNotifications() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNotificationListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async markAsReadNotification({ commit }, payload) {
    return apiClient
      .route(
        NotificationMarkAsReadController.post({ notification: payload }),
        {}
      )
      .then((response) => response.data)
  },

  async fetchNotificationSubscriptions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNotificationSubscriptionByDossierIdController.get({
            id: payload.id
          }),
          {
            params: {
              model: payload.model
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  //region edit
  updateNotificationSubscription: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateNotificationSubscriptionByDossierIdController.put({
            id: payload.id
          }),
          {
            model: payload.model,
            notification_subscriptions: payload.notification_subscriptions
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  sendNotificationToUsers: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SendNotificationToUsers.post(), {
          user_ids: payload.user_ids,
          text: payload.text,
          title: payload.title,
          via: payload.via
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
